import FilterApartment from './FilterApartment.vue';

export { FilterApartment };
export default FilterApartment;
